import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import swapArrayItem from 'scaleflow/utils/swapArrayItem';

export default class ListAssigneeBadgeComponent extends Component {
  @service currentUser;

  get showMultipleAvatars() {
    return this.assignees.length > 1;
  }

  @cached
  get assignees() {
    if (this.args.item.id === null) return [];
    let _assignees = this.args?.item?.get('assignees')?.content?.slice() ?? [];
    const currentUserIndex = _assignees.findIndex(
      (item) => item.id === this.currentUser.id,
    );
    if (currentUserIndex >= 0) {
      _assignees = swapArrayItem.call(_assignees, 0, currentUserIndex);
    }
    return _assignees;
  }

  get displayAvatar() {
    const assignees = this.assignees;
    const assigneeLength = assignees.length;
    if (assigneeLength === 2) {
      return assignees.at(1);
    } else {
      return {
        color: 'gray',
        abbreviation: `+${assigneeLength - 1}`,
        name: '',
      };
    }
  }

  get assigneeIds() {
    return this.assignees.map((item) => item.id);
  }

  get multipleAssigneesLabel() {
    const assignees = this.assignees;
    return assignees.map((item) => item.name);
  }

  get firstAssignee() {
    return this.assignees[0] ?? this.args.item.author;
  }

  @action
  handleSelect(values) {
    this.args?.onSelect?.(values);
  }
}
